import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';


export const isVerticalDirection = (textDirection?: TextDirectionType) => textDirection === TextDirectionType.VERTICAL
    || textDirection === TextDirectionType.ROTATE_90
    || textDirection === TextDirectionType.WORD_ART_VERTICAL_RTL
    || textDirection === TextDirectionType.WORD_ART_VERTICAL_LTR
    || textDirection === TextDirectionType.ROTATE_270;

/**
 *
 * @param textDirection 排列方向 | 是否竖排
 * @returns 逻辑属性key
 * 关于逻辑属性：https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties
 */
export const getLogicPropertyKeyMap = (textDirection?: TextDirectionType | boolean) => {
    let isVert;
    if (typeof textDirection === 'boolean') {
        isVert = textDirection;
    } else {
        isVert = isVerticalDirection(textDirection);
    }
    return isVert
        ? {
            inlineSize: 'height',
            inlineStart: 'top',
            inlineEnd: 'bottom',
            blockSize: 'width',
            blockStart: 'left',
            blockEnd: 'right',
            offsetInlineStart: 'offsetTop',
            offsetInlineEnd: 'offsetBottom',
            offsetInlineSize: 'offsetHeight',
            clientInlineSize: 'clientHeight',
        } : {
            inlineSize: 'width',
            inlineStart: 'left',
            inlineEnd: 'right',
            blockSize: 'height',
            blockStart: 'top',
            blockEnd: 'bottom',
            offsetInlineStart: 'offsetLeft',
            offsetInlineEnd: 'offsetRight',
            offsetInlineSize: 'offsetWidth',
            clientInlineSize: 'clientWidth',
        };
};
